const API_ENDPOINTS = {
  baseURL: process.env.REACT_APP_API_URL,
  AUTH: {
    Login: `/api/v1/login`,
    Profile: `/api/v1/users/profile`,
    ReSendOtp: `/api/v1/login/resend-otp`,
    ValidateOtp: `/api/v1/login/validate-otp`
  },
  PROPERTIES: {
    AddProperty: `/api/v1/properties`,
    GetPropertyList: `/api/v1/properties`,
    GetCityList: `/api/v1/cities`,
    GetStateList: `/api/v1/states`,
    GetSellYourProperties: `/api/v1/properties/sell`,
    DeletePropertyImage: `/api/v1/properties/image`,
    PropertySaveAsDraft: `/api/v1/properties/save-as-draft`,
    DownloadProperties: `/api/v1/properties/export`,
  },
  PROPERTY_TYPE: {
    AddPropertyType: `/api/v1/property-type`,
  },
  AMENITIES: {
    amenitiesList: `/api/v1/amenities`,
  },
  PRE_SIGNED_URL: `/api/v1/media/pre-signed-upload-url`,
  MEDIA: {
    PreSignedUploadUrl: `/api/v1/media/pre-signed-upload-url`,
    PreSignedBulkEmail: `/api/v1/media/pre-signed-upload-url-bulk-email`
  },
  AMENITY: {
    AddAmenity: `/api/v1/amenities`,
  },
  USERS: {
    GetUsers: `/api/v1/users`,
    GetNonUSUsers: `/api/v1/users/non-us`,
    GetDuplicateUsers: `/api/v1/users/duplicate/list`,
    FreezeUser: `/api/v1/users`,
    UserDetails: `/api/v1/users`,
    ManualKYC: `/api/v1/users/manual-kyc-aml`,
    InvestedProperties: `/api/v1/users/property/invested`,
    SavedProperties: `/api/v1/users/property/saved`,
    AccountStatement: `/api/v1/users/account-statement`,
    SendEmail: `/api/v1/users/email`,
    SendSms: `/api/v1/users/sms`,
    Notifications: `/api/v1/users/notifications`,
    NotificationsUser: `api/v1/users/notification-users`,
    DownloadUsers: `api/v1/users/download`,
    Approve: `api/v1/users/approve`,
    ResetPinPassword: `api/v1/users/reset/pin-password`,
  },
  LEGAL_POLICY: {
    GetPolicyTypes: `/api/v1/legal/type`,
    GetPolicy: `/api/v1/legal`,
  },
  FAQS: {
    GetFAQ: `/api/v1/faq`,
    UpdateFAQOrder: `/api/v1/faq/set-order`,
  },
  FINANCE: {
    GetBankAcc: `/api/v1/property-type/bank/accounts`,
    AddBankAcc: `/api/v1/property-type/bank`,
    VerifyDeposits: `/api/v1/property-type/verify-deposits`,
    massTransfer: `/api/v1/properties/mass-transfer`,
    GetSecondaryProperties: `/api/v1/properties/secondary`,
    GetDividendList: `/api/v1/properties/finance/dividend-disbursement`,
  },
  TRANSACTIONS: {
    PrimaryTransactions: `/api/v1/transactions/primary`,
    SecondaryTransactions: `/api/v1/transactions/secondary`,
    PendingTransactions: `/api/v1/transactions/pending`,
    CancelTransactions: `/api/v1/transactions/cancelled`,
    WithdrawalTransactions: '/api/v1/transactions/withdawal',
    ApproveTransactions: 'api/v1/users/approve-transfer',
    DownloadTransactions: `/api/v1/transactions/download`,
  },
  DASHBOARD: {
    GetWidgets: '/api/v1/dashboard',
    GetPropertyChart: `/api/v1/dashboard/property-chart`,
    GetInvestorChart: `/api/v1/dashboard/investor-chart`,
    GetRecentProperty: `/api/v1/dashboard/properties`,
    GetNotifications: `/api/v1/dashboard/notifications/all`,
  },
  REPORTS: {
    GetRevenueReports: `/api/v1/reports/revenue`,
    GetRecurringRevenueReports: `/api/v1/reports/revenue/recurring`,
    UsersAcquiredReports: `/api/v1/reports/users/acquired`,
    UsersByStateReports: `/api/v1/reports/users/state`,
    UsersByAgeReports: `/api/v1/reports/users/age`,
    MostLikedProperties: `/api/v1/reports/properties/liked`,
    MostAppreciatedProperties: `/api/v1/reports/properties/appreciated`,
    MostTradedProperties: `/api/v1/reports/properties/traded`,
    GetRevenueCharts: `/api/v1/reports/chart/revenue`,
    GetRecurringRevenueCharts: `/api/v1/reports/chart/recurring-revenue`,
    GetAcquiredUsersCharts: `/api/v1/reports/chart/user`,
    GetUsersStateCharts: `/api/v1/reports/chart/user-state`,
    DownloadReports: `/api/v1/reports/download`,
  },
  FUNDINGSOURCE: {
    GetFundingSources: `/api/v1/users/funding-sources/removal`,
    deleteFundingSource: `/api/v1/users/funding-source`,
    deleteFundingSourceRequest: `/api/v1/users/decline-funding-source`,
    GetDeactivatedUsersList: `/api/v1/users/deactivated/list`,
  }
};

export default API_ENDPOINTS;
